import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Checkout = () => {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [email, setEmail] = useState("");
  const [shipping, setShipping] = useState(0);
  const [zone, setZone] = useState("");
  const [payment, setPayment] = useState("creditCard");

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    cardNumber: "",
    expiry: "",
    cvv: "",
    cardName: "",
  });

  useEffect(() => {
    setCartItems(JSON.parse(sessionStorage.getItem("cart")) || []);
    setEmail(sessionStorage.getItem("userEmail") || "");

    const zones = [
      { name: "East Coast", price: 8.99 },
      { name: "West Coast", price: 12.49 },
      { name: "Midwest", price: 9.79 },
      { name: "South", price: 14.89 },
      { name: "Central", price: 6.75 },
    ];
    const z = zones[Math.floor(Math.random() * zones.length)];
    setZone(z.name);
    setShipping(z.price);
  }, []);

  const subtotal = cartItems.reduce((a, i) => a + i.price * i.quantity, 0);
  const tax = subtotal * 0.1;
  const total = subtotal + tax + shipping;

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const placeOrder = () => {
    const required = [
      "firstName",
      "lastName",
      "phone",
      "address",
      "city",
      "state",
      "zip",
    ];

    for (let r of required) {
      if (!form[r]) {
        toast.error("Please complete all required fields");
        return;
      }
    }

    if (payment === "creditCard") {
      if (!form.cardNumber || !form.expiry || !form.cvv || !form.cardName) {
        toast.error("Enter full card details");
        return;
      }
    }

    sessionStorage.setItem("lastOrder", JSON.stringify(cartItems));
    sessionStorage.setItem("orderTotal", total.toFixed(2));
    sessionStorage.removeItem("cart");

    toast.success("Order placed successfully 🎉");
    setTimeout(() => navigate("/order-confirmed"), 900);
  };

  return (
    <section className="sx-checkout">
      <div className="sx-wrap">
        {/* LEFT */}
        <div className="sx-form">
          <h2>Checkout</h2>

          <div className="sx-step">
            <h4>Customer Details</h4>
            <div className="sx-grid">
              <input
                placeholder="First Name"
                name="firstName"
                onChange={handleChange}
              />
              <input
                placeholder="Last Name"
                name="lastName"
                onChange={handleChange}
              />
              <input placeholder="Email" value={email} disabled />
              <input placeholder="Phone" name="phone" onChange={handleChange} />
            </div>
          </div>

          <div className="sx-step">
            <h4>Shipping Address</h4>
            <input
              placeholder="Street Address"
              name="address"
              onChange={handleChange}
            />
            <div className="sx-grid">
              <input placeholder="City" name="city" onChange={handleChange} />
              <input placeholder="State" name="state" onChange={handleChange} />
              <input
                placeholder="ZIP Code"
                name="zip"
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="sx-step">
            <h4>Payment</h4>
            <div className="sx-pay">
              <label style={{ display: "flex" }}>
                <input
                  type="radio"
                  checked={payment === "creditCard"}
                  onChange={() => setPayment("creditCard")}
                />
                Credit Card
              </label>
              <label style={{ display: "flex" }}>
                <input
                  type="radio"
                  checked={payment === "cod"}
                  onChange={() => setPayment("cod")}
                />
                Cash on Delivery
              </label>
            </div>

            {payment === "creditCard" && (
              <>
                <input
                  placeholder="Card Number"
                  name="cardNumber"
                  onChange={handleChange}
                />
                <div className="sx-grid">
                  <input
                    placeholder="MM/YY"
                    name="expiry"
                    onChange={handleChange}
                  />
                  <input placeholder="CVV" name="cvv" onChange={handleChange} />
                </div>
                <input
                  placeholder="Name on Card"
                  name="cardName"
                  onChange={handleChange}
                />
              </>
            )}
          </div>
        </div>

        {/* RIGHT */}
        <div className="sx-summary">
          <h4>Order Summary</h4>

          {cartItems.map((i) => (
            <div key={i.id} className="sx-row">
              <span>{i.name}</span>
              <strong>${(i.price * i.quantity).toFixed(2)}</strong>
            </div>
          ))}

          <hr />

          <div className="sx-row">
            <span>Subtotal</span>
            <strong>${subtotal.toFixed(2)}</strong>
          </div>
          <div className="sx-row">
            <span>Shipping ({zone})</span>
            <strong>${shipping.toFixed(2)}</strong>
          </div>
          <div className="sx-row">
            <span>Tax</span>
            <strong>${tax.toFixed(2)}</strong>
          </div>

          <div className="sx-total">
            Total <span>${total.toFixed(2)}</span>
          </div>

          <button onClick={placeOrder} className="sx-btn">
            Place Order
          </button>
        </div>
      </div>

      <style>{`
        .sx-checkout {
          background:#f4f6fb;
          padding:60px 0;
        }
        .sx-wrap {
          max-width:1200px;
          margin:auto;
          display:grid;
          grid-template-columns: 1.3fr .7fr;
          gap:30px;
        }
        .sx-form, .sx-summary {
          background:#fff;
          padding:30px;
        }
        .sx-form h2 {
          margin-bottom:20px;
        }
        .sx-step {
          margin-bottom:26px;
        }
        .sx-step h4 {
          margin-bottom:12px;
          font-size:16px;
        }
        .sx-form input {
          width:100%;
          padding:12px;
          margin-bottom:12px;
          border:1px solid #d1d5db;
          font-size:14px;
        }
        .sx-grid {
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:12px;
        }
        .sx-pay {
          display:flex;
          gap:20px;
          margin-bottom:12px;
        }
        .sx-summary h4 {
          margin-bottom:20px;
        }
        .sx-row {
          display:flex;
          justify-content:space-between;
          margin-bottom:10px;
          font-size:14px;
        }
        .sx-total {
          margin:18px 0;
          font-size:18px;
          font-weight:700;
          display:flex;
          justify-content:space-between;
        }
        .sx-btn {
          width:100%;
          padding:14px;
          background:#111;
          color:#fff;
          border:none;
          font-weight:600;
          cursor:pointer;
        }
        @media(max-width:900px){
          .sx-wrap{
            grid-template-columns:1fr;
          }
        }
      `}</style>
    </section>
  );
};

export default Checkout;
